import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Ladder } from 'src/models/ladder.model';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'dialog-admin-set-ladder',
  templateUrl: './dialogAdminSetLadder.component.html'
})
export class AdminDialogSetLadderComponent {
  public ladder: number;
  public ladders: Ladder[] = [];

  constructor(private dialogRef: MatDialogRef<AdminDialogSetLadderComponent>, private http: HttpClient, private usrSvc: UserService) {
    this.http.get('/ladders').subscribe(
      (resp: Ladder[]) => {
        this.ladders = resp.map(m => new Ladder(m));
      },
      (err) => {

      }
    );
  }

  public cancel(evt:any) {
    evt.preventDefault();
    this.dialogRef.close();
  }

  public save() {
    // this.http.post(this.level).subscribe(
    //   (player) => this.dialogRef.close(this.level),
    //   (err) => alert(err)
    // )
    
    this.dialogRef.close(this.ladder);
  }
}